<template>
  <div>
    <el-tag v-if="tag" :type="tag.type" :hit="true" size="small">
      {{ tag.label }}
      <el-popover
        v-if="reason || state === 'rejected'"
        placement="bottom"
        title="Reason"
        :width="500"
        effect="dark"
        trigger="hover"
        :enterable="true"
      >
        <template #default>
          <div class="reason-text">{{ reason || 'No reason provided' }}</div>
          <router-link
            v-if="state === 'rejected' && editUrl"
            :to="editUrl"
            class="reason-link"
          >
            Fix problem now
          </router-link>
        </template>
        <template #reference>
          <span class="reason-icon" tabindex="0" aria-label="Rejection reason">
            <font-awesome-icon icon="question-circle" />
          </span>
        </template>
      </el-popover>
    </el-tag>
    <router-link
      v-if="noFunds"
      to="/payment"
      class="top-up-btn el-button el-button--default el-button--primary el-button--mini"
    >
      Top up
    </router-link>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import { CreativeStateLabels, CreativeState } from '@/api/types'
import { NO_FUNDS_STATE } from '@/apps/traforama/constants'

export default defineComponent({
  name: 'CreativeState',
  props: {
    state: {
      type: String,
      default: ''
    },
    reason: {
      type: String,
      default: ''
    },
    editUrl: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const tag = computed(() => {
      const state = props.state as CreativeState
      return CreativeStateLabels[state]
    })

    const noFunds = computed(() => {
      const state = props.state as CreativeState
      return state === NO_FUNDS_STATE
    })

    return { tag, noFunds }
  }
})
</script>
<style lang="scss" scoped>
.el-tag {
  border: none !important;
}
.top-up-btn {
  height: 20px;
  margin-left: 5px;
}
.el-button--mini {
  padding: 2px 10px;
}
.reason-link {
  display: inline-block;
  margin-top: 8px;
  color: #409eff;
  text-decoration: underline;
  cursor: pointer;
  &:hover {
    color: #66b1ff;
  }
}
.reason-text {
  white-space: pre-line;
  overflow-wrap: anywhere;
}
.reason-icon {
  margin-left: 4px;
  cursor: help;
}
</style>
